<template>
    <div class="td-cmp section cmp-notes-list">

        <status-message></status-message>

        <h2 class="active section-heading" @click="toggleFilter">
            <span class="icon-heading"><icon class="icon" type="solid" name="faStickyNote" aria-hidden="true"></icon> Listing Notes</span>
            <span class="icon-heading"><icon class="icon" type="solid" name="faFilter" aria-hidden="true"></icon></span>
        </h2>

        <div v-if="showFilter" class="td-card rounded md-col-2 notes-filters">
            <div>
                <strong><label class="td-inline" for="cmp-listing-list-region">Date Range</label></strong>
                <VueDatePicker v-model="range" type="date" placeholder="Date range" :range="true" :format="'yyyy-MM-dd'" />
            </div>

            <div>
                <strong><label class="td-inline">Filter by State or City</label></strong>
                <select v-model="regionCode" :disabled="isLoading" class="td-select">
                    <option value="">Filter by state/prov. (optional)</option>
                    <optgroup label="United States">
                        <option v-for="item in usRegions" :value="item.code">{{ item.name }}</option>
                    </optgroup>
                    <optgroup label="Canada">
                        <option v-for="item in caRegions" :value="item.code">{{ item.name }}</option>
                    </optgroup>
                </select>
                <input v-model="city" :disabled="isLoading" v-if="showCity" placeholder="City" />
            </div>

            <div>
                <div v-if="isFleet && !isAdmin" class="form-field">
                    <label class="td-checkbox-label">
                        <input type="checkbox" v-model="includeAll" :disabled="isLoading" /><span></span>
                        Include all notes on account
                    </label>
                </div>


                <div v-if="isAdmin" class="form-field">
                    <label class="td-checkbox-label">
                        <input type="checkbox" v-model="includeAll" :disabled="isLoading" /><span></span>
                        Include all notes
                    </label>
                </div>

                <div class="form-field">
                    <label class="td-checkbox-label">
                        <input type="checkbox" v-model="includeRatings" :disabled="isLoading" /><span></span>
                        Include ratings
                    </label>
                </div>

                <div v-if="isFleet" class="form-field">
                    <label v-if="isFleet" class="td-checkbox-label">
                        <input type="checkbox" v-model="includePreferences" :disabled="isLoading" /><span></span>
                        Include network preferences
                    </label>
                </div>
            </div>

            <div></div>

            <div class="filter-action">
                <button @click="search" class="td-btn primary-outlined td-full-width">
                    <icon v-if="isLoading" type="solid" name="faSpinner" spin aria-hidden="true"></icon>
                    <span v-else>Search</span>
                </button>
            </div>
        </div>

        <div class="content">
            <div class="pagination td-card shadow top">
                <div class="td-text-subdued td-text-italic td-text-mice">
                    {{ pagerText }}
                </div>
                <div class="td-pagination-btns my-1 slim">
                    <button :disabled="!pagerEnablePrevious" :class="['secondary', 'previous', {'disabled': !pagerEnablePrevious}]"
                            @click.prevent="pagerPrevious"
                            title="Previous Page">
                        <icon v-if="isLoading" type="solid" name="faSpinner" spin aria-hidden="true"></icon>
                        <icon v-if="!isLoading" type="solid" name="faAngleLeft" aria-hidden="true"></icon>
                    </button>
                    <button :class="['next', 'secondary', {'disabled': !pagerEnableNext}]"
                            @click.prevent="pagerNext"
                            title="Next"
                            :disabled="!pagerEnableNext">
                        <icon v-if="isLoading" type="solid" name="faSpinner" spin aria-hidden="true"></icon>
                        <icon v-if="!isLoading" type="solid" name="faAngleRight" aria-hidden="true"></icon>
                    </button>
                </div>
            </div>


            <!--  NOTES -->
            <!-- IF NOT NOTES DISPLAYED -->
            <div v-if="isLoading">
                <icon v-if="isLoading" type="solid" name="faSpinner" spin aria-hidden="true"></icon>
            </div>
                <note v-if="!isLoading" :isAdmin="isAdmin" :note="note" v-for="note in notes" :key="note.id" @onEdit="editNote" @onDelete="deleteNote"></note>
                <div v-if="!isLoading && notes.length == 0">
                    <p>There are no Notes to display.</p>
                    <p v-if="!isAdmin">You can add a private note to any vendor by <a href="/" title="Run a search">running a search</a> and clicking on the notes in the business listing.</p>
                </div>


                <div class="pagination td-card shadow top">
                    <div class="td-text-subdued td-text-italic td-text-mice">
                        {{ pagerText }}
                    </div>
                    <div class="td-pagination-btns my-1 slim">
                        <button :disabled="!pagerEnablePrevious" :class="['secondary', 'previous', {'disabled': !pagerEnablePrevious}]"
                                @click.prevent="pagerPrevious"
                                title="Previous Page">
                            <icon v-if="isLoading" type="solid" name="faSpinner" spin aria-hidden="true"></icon>
                            <icon v-if="!isLoading" type="solid" name="faAngleLeft" aria-hidden="true"></icon>
                        </button>
                        <button :class="['next', 'secondary', {'disabled': !pagerEnableNext}]"
                                @click.prevent="pagerNext"
                                title="Next"
                                :disabled="!pagerEnableNext">
                            <icon v-if="isLoading" type="solid" name="faSpinner" spin aria-hidden="true"></icon>
                            <icon v-if="!isLoading" type="solid" name="faAngleRight" aria-hidden="true"></icon>
                        </button>
                    </div>
                </div>
            </div>

    </div>
</template>

<script>
import script from './NotesList';
    export default script;</script>

<style lang="less">
    @import "./NotesList.less";
</style>